import React from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { broadcastNameSchema } from "../shemas/broadcast";
import { SelectTagHead, SelectTagWidgetContainer, TableHeaderText } from "../../BroadcastView.styles";
import { BroadcastAppCard, Container, ContainerActions, FormContainer, FormInput, FormInputContainer, FormInputDescription, FormInputError, FormInputLabel, ListContainer, ListContent, ListContentItem, ListTitle } from "../styles";
import { BackLink } from "../../Campaigns.style";
import Button from "../../../../../components/shared/components/button/Button.style";

export const NameBroadcastForm = ({ handleNext, updateBroadcastData, broadcastData }) => {
  const history = useHistory();

  const { register, handleSubmit, errors } = useForm({
    validationSchema: broadcastNameSchema,
    defaultValues: {
      broadcastName: broadcastData?.broadcastName || "",
    },
    mode: "onChange",
  });

  const onSubmit = (data) => {
    updateBroadcastData({
      broadcastName: data.broadcastName.trim(),
    })
    handleNext()
  };

  return (
      <SelectTagWidgetContainer>
        <BroadcastAppCard
        >
          <BackLink onClick={() => history.push("/broadcast/type")}>
            ← Regresar
          </BackLink>

          <SelectTagHead>
              <TableHeaderText>
                Envía un mensaje a varias personas al mismo tiempo creando
                campañas. Puedes usar una lista de contactos en un archivo Excel.
              </TableHeaderText>
          </SelectTagHead>

          <Container>
            <FormContainer onSubmit={handleSubmit(onSubmit)}>
              <FormInputContainer>
                <FormInputLabel htmlFor="broadcastName">
                  Nombre de la campaña
                </FormInputLabel>

                <FormInput
                  name="broadcastName"
                  type="text"
                  placeholder="Ej. Promos Buen Fin"
                  ref={register}
                />

                <FormInputDescription>
                  Un buen nombre te ayuda a tener un buen seguimiento después.
                </FormInputDescription>

                {errors.broadcastName && (
                  <FormInputError>{errors.broadcastName.message}</FormInputError>
                )}
              </FormInputContainer>
            </FormContainer>

            <ListContainer>
              <ListTitle>Buenas Prácticas</ListTitle>

              <ListContent>
                <ListContentItem>
                  Listas con consentimiento.
                </ListContentItem>

                <ListContentItem>
                  Botón claro para responder o dejar de recibir.
                </ListContentItem>

                <ListContentItem>
                  Mensaje breve, directo y útil.
                </ListContentItem>
              </ListContent>
            </ListContainer>
          </Container>

          <ContainerActions>
            <Button
              designV4
              type="submit"
              onClick={handleSubmit(onSubmit)}
            >
              Continuar
            </Button>
          </ContainerActions>
        </BroadcastAppCard>
      </SelectTagWidgetContainer>
  )
}